import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { initAdsTracking, track } from "@/lib/track";

const SettingsContext = createContext(null);

const DEFAULTS = {
  store_name: "The Pet Shopping Co",
  tagline: "Todo para consentir a tu mascota 🐾",
  whatsapp_number: "50688820333",
  currency: "₡",
  country: "Costa Rica",
  hero_title: "Amor y cuidado para tu mejor amigo",
  hero_subtitle: "Alimento premium y accesorios seleccionados con cariño para perros, gatos y más. Envíos a todo Costa Rica.",
  instagram_url: "https://instagram.com/petshoppingcompany",
  facebook_url: "https://facebook.com/petshoppingcompany",
  tiktok_url: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
      initAdsTracking(data);
    } catch {
      setSettings(DEFAULTS);
    }
  };

  useEffect(() => {
    refresh();
    track("page_view");
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
